import React, { Component } from "react";
import { CardInfoChangeControl } from "../../controls/CardInfoChangeControl";
import { ControlRenderer } from "components/renderers/ControlRenderer";
import { CtrlCollection } from "@yuigoto/ctrl";
import { connect } from "react-redux";
import { ExecuteRequest } from "core/glambox/GlamboxApi";
import { GlamboxEndpoints } from "core/glambox/GlamboxEndpoints";
import { UiActions } from "state/actions/UiActions";
import { CreditCard } from "utils/CreditCard";

class CardInfoChange extends Component {

    constructor(props) {
        super(props);

        this.state = {
            validationMessage: ""
        }

        this.collection = new CtrlCollection();
        for (let i = 0; i < CardInfoChangeControl.length; i++) {
            this.collection.add(CardInfoChangeControl[i]);
        }

        this.submitCard = this.submitCard.bind(this);
        this.validateCardData = this.validateCardData.bind(this);
    }

    showValidationMessage() {
        const validationMessage = this.state.validationMessage;
        return (<h3>{validationMessage}</h3>);
    }

    validateCardData() {

        if (this.props.cardData.creditCard === null) {
            this.props.errorAlert("Dados do cartão não encontrados");
            return false;
        }

        return true;
    }

    componentDidMount() {
        if (this.validateCardData()) {
            this.collection.setValue("creditCardNumber", this.props.cardData.number);
            this.collection.setValue("creditCardName", this.props.cardData.nameOnCard);
        }

        this.forceUpdate();
    }

    validateMonthAndYear = () => {
        let d = new Date();
        let currentYear = d.getFullYear();
        let currentMonth = d.getMonth() + 1;

        let year = this.collection.getValue("creditCardExpirationYear") + 2000;
        let month = this.collection.getValue("creditCardExpirationMonth");

        if (year < currentYear || (year == currentYear && month < currentMonth) || month > 12) {
            return false;
        }

        return true;
    }

    submitCard(event) {
        event.preventDefault();

        let isValid = this.collection.validate();
        let isDateValid = this.validateMonthAndYear();
        let creditCard = this.collection.getValue("creditCardNumber");
        let cardFlag = CreditCard.getCardFlag(creditCard);

        if (isValid && cardFlag && isDateValid) {

            ExecuteRequest(
              GlamboxEndpoints.Subscriber.changeCreditCard,
              Object.assign(
                {},
                this.collection.toObject(),
                {
                  creditCardFlagId: cardFlag.id,
                  subscriberId: this.props.subscriberId
                }
              ),
              "PUT",
              {
                Authorization: this.props.token.Authorization
              },
              null,
              (response) => {
                const {
                  result,
                  statusCode
                } = response;

                if (statusCode === 200) {
                  let aux = this.collection.toObject()
                  let number = aux.creditCardNumber;

                  this.props.successAlert(
                    result && result.message 
                      ? result.message 
                      : "Dados de cartão atualizados com sucesso."
                  );

                  this.props.callback(
                      Object.assign({},
                      {number: number.substr(0, number.length - 4).replace(/(.)/g, "*") + "-" + number.substr(-4), expYear: aux.creditCardExpirationYear, expMonth: aux.creditCardExpirationMonth, flag: cardFlag.name, nameOnCard: aux.creditCardName })
                  );

                  this.props.onCloseModal();
                } else {
                  this.props.errorAlert(
                    result && result.message 
                      ? result.message 
                      : "Não foi possível atualizar os dados de seu cartão de crédito. Por favor, tente novamente."
                  );
                }
              }
            )
        }
        else {
            if(!isValid){
                this.props.errorAlert("Campos inválidos");
            }
            else if (cardFlag === null) {
                this.props.errorAlert("Bandeira do cartão não encontrada");
            }
            else if(!isDateValid){
                this.props.errorAlert("Validade do cartão inválida");
            }
            
            this.forceUpdate();
            return;
        }
    }

    render() {
        return (
            <div>
                <form>
                    {ControlRenderer.renderCollection(this.collection)}
                    <input type="submit" onClick={this.submitCard}></input>
                    {this.showValidationMessage()}
                </form>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.user,
        token: state.token.data
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        successAlert: (message) => {
            dispatch(UiActions.publishSuccessAlert(message))
        }
        , errorAlert: (message) => {
            dispatch(UiActions.publishErrorAlert(message))
        }
    }
}

CardInfoChange = connect(mapStateToProps, mapDispatchToProps)(CardInfoChange);

export { CardInfoChange };